export default "__VITE_ASSET__BijFZ6yu__"